import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ref } from "vue";
import { getData } from "@/services/axios";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
import DekitusIntroduction from "@/components/common/DekitusIntroduction";
export default {
  __name: 'Index',
  setup: function setup(__props) {
    var dekitusStudents = ref([]);
    var isLoading = ref(false);

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                isLoading.value = true;
                _context.next = 4;
                return getData("dekitus_student?with=student.classroom");

              case 4:
                data = _context.sent;
                dekitusStudents.value = data.items;
                isLoading.value = false;
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                isLoading.value = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }();

    setData();
    return {
      __sfc: true,
      dekitusStudents: dekitusStudents,
      isLoading: isLoading,
      setData: setData,
      LoadingMessage: LoadingMessage,
      DekitusIntroduction: DekitusIntroduction
    };
  }
};